import React from 'react';
import type { ImageComponentConfig } from '@/types/page';
import { getSpacingStyle, getBorderRadiusStyle } from '@/utils/pageUtils';

interface ImageComponentProps {
  config: ImageComponentConfig;
}

export default function ImageComponent({ config }: ImageComponentProps) {
  const imageUrl = config.imageUri;

  if (!imageUrl) {
    return null;
  }

  // 应用 spacing 样式
  const spacingStyle = getSpacingStyle(config.spacing);
  // 应用 borderRadius 样式
  const borderRadiusStyle = getBorderRadiusStyle(config.borderRadius);

  // 图片容器样式
  const containerStyle: React.CSSProperties = {
    ...spacingStyle,
  };

  // 图片样式
  const imageStyle: React.CSSProperties = {
    width: '100%',
    height: 'auto',
    display: 'block',
    ...borderRadiusStyle,
  };

  // 渲染图片
  const imageElement = (
    <div style={containerStyle}>
      <img
        src={imageUrl}
        alt={config.alt || '图片'}
        style={imageStyle}
        loading="lazy"
      />
    </div>
  );

  // 如果有链接，包裹 <a> 标签
  if (config.link) {
    return (
      <a href={config.link} target="_blank" rel="noopener noreferrer">
        {imageElement}
      </a>
    );
  }

  return imageElement;
}
